/**
 * "LV N" pill (specs/rank-on-social-screens §Story 2, design 1b). Companion to
 * PlayerRankBadge: the crest says which rank, this says how far into it.
 *
 * Like the crest, positioning is the caller's — the pill either overlaps an avatar's bottom
 * edge or sits in a name block's slack, so that no row or card grows to fit it (§7).
 */

import React, { useMemo } from 'react';
import { Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { PLAYER_RANK_TEST_IDS } from '../../constants/playerRanks.constants';
import { getPlayerLevelPillStyles, type PlayerLevelPillSize } from './PlayerLevelPill.styles';

export interface PlayerLevelPillProps {
  level: number;
  /** 'sm' for dense leaderboard rows, 'md' at header scale. Default 'sm'. */
  size?: PlayerLevelPillSize;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

export const PlayerLevelPill: React.FC<PlayerLevelPillProps> = ({
  level,
  size = 'sm',
  style,
  testID,
}) => {
  const styles = useMemo(() => getPlayerLevelPillStyles(size), [size]);

  return (
    <View
      style={[styles.pill, style]}
      // Never swallow the press of the card or row it sits on (AC-13).
      pointerEvents="none"
      testID={testID ?? PLAYER_RANK_TEST_IDS.levelPill}
    >
      <Text style={styles.pillText}>LV {level}</Text>
    </View>
  );
};
